import * as React from "react";
import { SVGProps } from "react";
const SvgUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 20.002a1 1 0 0 1 1 1v4c0 2.206-1.794 4-4 4H8c-2.206 0-4-1.794-4-4v-4a1 1 0 1 1 2 0v4c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-4a1 1 0 0 1 1-1ZM14.973 2.34a1.707 1.707 0 0 1 2.045 0c2.425 1.79 5.038 4.475 7.767 7.981a.999.999 0 1 1-1.578 1.228c-2.04-2.62-3.997-4.747-5.84-6.356L17 4.878v15.124a1 1 0 0 1-1.993.117L15 20.002V4.872c-1.954 1.644-4.038 3.88-6.215 6.678a1 1 0 1 1-1.578-1.228c2.726-3.503 5.339-6.189 7.766-7.982Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUpload;
